<!-- TODOS ADD REMOVE splitlayout for layout switch-->
<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pt-0 pb-3 px-3 globalborder-btm-header mb-2">
        <span class="col-auto">
          <h2 class="mb-0">
            Invoice Preview : {{ invoicePreviewNumber }}
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>

        <span class="d-flex gap-3 customizefilter-btn align-items-center px-3">
          <div
            class="ordersummary-total ordersummary-col d-flex align-items-center gap-2">
            <!-- <h2>Invoice Preview: {{ invoicePreviewNumber }}</h2> -->
            <p-button
              label="Print"
              *ngIf="reportBase64String"
              (click)="onPdfView()" />
            <!-- <button
              type="button"
              class="primarybtn bluebtn ms-2"
              *ngIf="reportBase64String"
              (click)="onPdfView()">
              Print
            </button> -->
            <h2 class="mb-0">{{ clientName }}</h2>
          </div>
          <div class="d-flex gap-2 align-items-center">
            <label> Preview: </label>
            <label class="ms-2 radiobtnholder">
              <p-radioButton
                inputId="On"
                class="me-2"
                [(ngModel)]="showPdfViewer"
                [value]="true"
                (onClick)="onPreviewChange(true)" />
              On
            </label>
            <label class="ms-2 radiobtnholder">
              <p-radioButton
                inputId="Off"
                class="me-2"
                [(ngModel)]="showPdfViewer"
                [value]="false"
                (onClick)="onPreviewChange(false)" />
              Off
            </label>
          </div>
          <div class="d-flex d-flex align-items-center">
            Approval Status:
            <b class="px-1">
              <p-select
                [(ngModel)]="defaultInvoicePreviewStatus"
                (onChange)="onApprovalSelection($event)"
                [disabled]="
                  invoicePreviewSummary?.lineProperty === 'Invoiced' ||
                  invoicePreviewSummary?.lineProperty === 'Canceled'
                "
                [showClear]="false"
                [filter]="true"
                [options]="invoicePreviewStatus"
                optionLabel="name"
                optionValue="id">
              </p-select>
            </b>
            <!-- <b class="px-1"
              ><button
                type="button"
                class="primarybtn bluebtn disabledbtncss"
                (click)="updateInvoicePreviewStatus()"
                [disabled]="
                  invoicePreviewSummary.lineProperty === 'Invoiced' ||
                  defaultInvoicePreviewStatus === 'Open'
                ">
                Submit
              </button></b
            > -->

            <p-button
              label="Submit"
              (click)="updateInvoicePreviewStatus()"
              [disabled]="
                invoicePreviewSummary?.lineProperty === 'Invoiced' ||
                invoicePreviewSummary?.lineProperty === 'Canceled' ||
                approvalStatus === 'Approved' ||
                defaultInvoicePreviewStatus === 'Open'
              " />
          </div>

          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="adduser-container-hgt px-3">
        <div class="d-flex gap-3">
          <div class="col-lg col-sm-8">
            <div class="detailsection">
              <jni-invoice-preview-order-details
                [invoicePreviewSummary]="invoicePreviewSummary"
                [salesOrderId]="saleOrderId"
                [customerPONumber]="customerPONumber"
                [shippingMethodCode]="shippingMethodCode"
                [jobName]="jobName"
                (updateCustomerPONumberEvent)="updateCustomerPONumber($event)"
                (updateJobNameEvent)="updateJobNameEvent($event)"
                (updateShippingMethodEvent)="updateShippingMethodEvent($event)"
                (addScollHiddenClassEvent)="addScollHiddenClass()"
                [invoicePreviewNumber]="invoicePreviewNumber">
              </jni-invoice-preview-order-details>
            </div>
            <div>
              <div class="cstm-collaspse">
                <p-panel
                  class="col-12 collapseable zeroHeight"
                  [ngClass]="{ active: collapseOrderLineDetailsStatus }"
                  [toggleable]="true"
                  (onBeforeToggle)="onOrderLineDetailsToggle()"
                  [collapsed]="collapseOrderLineDetailsStatus"
                  [expandIcon]="'pi pi-angle-double-down'"
                  [collapseIcon]="'pi pi-angle-double-up'">
                  <ng-template #header>
                    <header
                      class="align-items-center d-flex has-border ordersummary-header">
                      <h2 class="mb-0">Order Line Details</h2>
                      <h2
                        class="mb-0"
                        *ngIf="
                          invoicePreviewLines.totalCount > 12 &&
                          !showLessOrderLinesSection
                        "
                        (click)="sellAllOrderLineDetails()">
                        More Sell Lines Exist
                      </h2>
                      <a
                        class="ms-1 link btncommitSyle"
                        *ngIf="
                          invoicePreviewLines.totalCount > 12 &&
                          !showLessOrderLinesSection
                        "
                        (click)="sellAllOrderLineDetails()"
                        >(See All)</a
                      >
                      <h2
                        class="mb-0 ms-5 btncommitSyle"
                        *ngIf="showLessOrderLinesSection"
                        (click)="showLessOrderLines()">
                        Show Less Lines
                      </h2>
                      <div
                        class="ordersummary-panel ml-auto d-flex justify-content-between marginleft-auto">
                        <div
                          class="form-check form-switch d-flex align-items-center mx-3 gap-2 justify-content-end">
                          <p-toggleswitch
                            (onChange)="includeNetOnlyLines($event)"
                            id="flexSwitchCheckDefault2"
                            name="flexSwitchCheckDefaul2" />
                          <label
                            class="form-check-label"
                            for="flexSwitchCheckDefault2">
                            Include Net Only Lines
                          </label>
                        </div>
                        <div
                          class="ms-3 nav-link p-0 d-flex align-items-center">
                          <!-- <a class="link" (click)="sellAllOrderLineDetails()">See All</a> -->
                        </div>
                      </div>

                      <!-- <div class="collapse-section border-0">
              <a
                class="btn-collapse"
                (click)="onOrderLineDetailsToggle()"
                [ngClass]="{ active: collapseOrderLineDetailsStatus }"
                >{{ collapseOrderLineDetailsHeading }}
                <i class="icon-angle-double"></i
              ></a>
            </div> -->
                    </header>
                  </ng-template>
                  <ng-template #icons class="d-flex align-items-center">
                    <div class="collapse-section border-0">
                      <a
                        class="btn-collapse"
                        (click)="onOrderLineDetailsToggle()"
                        [ngClass]="{ active: collapseOrderLineDetailsStatus }"
                        >{{ collapseOrderLineDetailsHeading }}
                      </a>
                    </div>
                  </ng-template>
                  <jni-invoice-preview-order-line-details
                    [orderLineDetailsGridListing]="orderLineDetailsGridListing"
                    (vendorInvoiceEvent)="vendorInvoiceSelection()"
                    [invoicePreviewLines]="invoicePreviewLines"
                    [orderLineDetailsConsumesMessage]="
                      orderLineDetailsConsumesMessage
                    "
                    [isFromIpSummary]="true">
                  </jni-invoice-preview-order-line-details>
                </p-panel>
              </div>
            </div>
            <div>
              <div class="cstm-collaspse">
                <p-panel
                  (onBeforeToggle)="onNotesToggle()"
                  [collapsed]="collapseNotesStatus"
                  [toggleable]="true"
                  [expandIcon]="'pi pi-angle-double-down'"
                  [collapseIcon]="'pi pi-angle-double-up'"
                  class="collapseable zeroHeight"
                  [ngClass]="{ active: collapseNotesStatus }">
                  <ng-template #header>
                    <header
                      class="align-items-center d-flex has-border mt-3 ordersummary-header pb-2">
                      <h2 class="m-0 wordwrap sec-title">Notes</h2>

                      <div
                        class="ordersummary-panel ml-auto d-flex justify-content-between">
                        <div
                          class="ms-3 nav-link p-0 d-flex align-items-center">
                          <a class="link" (click)="openSideBarForOrderNotes()">
                            <i class="pi pi-file-plus"></i> New</a
                          >
                        </div>
                      </div>
                      <div
                        class="ordersummary-panel ml-auto d-flex justify-content-between">
                        <div
                          class="ms-3 nav-link p-0 d-flex align-items-center">
                          <a class="link" (click)="updateSideBarForOrderNotes()"
                            ><i class="pi pi-pen-to-square"></i> Edit</a
                          >
                        </div>
                      </div>
                      <div
                        class="ordersummary-panel ml-auto d-flex justify-content-between"
                        *ngIf="selectedRadioButton !== 'Invoiced'">
                        <div
                          class="ms-3 nav-link p-0 d-flex align-items-center">
                          <a
                            class="link delcol"
                            (click)="deleteSideBarForOrderNotes()"
                            ><i class="pi pi-trash"></i> Delete</a
                          >
                        </div>
                      </div>
                    </header>
                  </ng-template>
                  <ng-template #icons>
                    <div class="collapse-section border-0 marginleft-auto">
                      <a
                        class="btn-collapse"
                        (click)="onNotesToggle()"
                        [ngClass]="{ active: collapseNotesStatus }"
                        >{{ collapseNotesHeading }}
                      </a>
                    </div>
                  </ng-template>
                  <jni-invoice-preview-order-notes
                    #ordernotes
                    [saleOrderId]="saleOrderId"
                    [isFromInvoiceSummary]="true"
                    [orderNotesGridListing]="orderNotesGridListing"
                    (selectedOrderNotesListing)="updateLineOnSideBar($event)">
                  </jni-invoice-preview-order-notes>
                </p-panel>
              </div>
            </div>

            <div>
              <div class="cstm-collaspse">
                <p-panel
                  class="collapseable zeroHeight"
                  (onBeforeToggle)="onOrderTrackingToggle()"
                  [collapsed]="collapseOrderTrackingStatus"
                  [toggleable]="true"
                  [expandIcon]="'pi pi-angle-double-down'"
                  [collapseIcon]="'pi pi-angle-double-up'"
                  [ngClass]="{ active: collapseOrderTrackingStatus }">
                  <ng-template #header>
                    <header
                      class="align-items-center d-flex has-border ordersummary-header">
                      <h2 class="mb-0">Order Tracking</h2>
                      <div
                        class="ordersummary-panel ml-auto d-flex justify-content-between">
                        <div
                          class="ms-3 nav-link p-0 d-flex align-items-center">
                          <a class="link" (click)="sellAllOrderTracking()"
                            >See All</a
                          >
                        </div>
                      </div>
                    </header>
                  </ng-template>
                  <ng-template #icons>
                    <div class="collapse-section border-0 marginleft-auto">
                      <a
                        class="btn-collapse"
                        (click)="onOrderTrackingToggle()"
                        [ngClass]="{ active: collapseOrderTrackingStatus }"
                        >{{ collapseOrderTrackingHeading }}</a
                      >
                    </div>
                  </ng-template>
                  <jni-invoice-preview-order-tracking
                    [orderTrackingGridListing]="orderTrackingGridListing"
                    [calculateTotalForAllLines]="true"
                    [salesId]="salesId"
                    [projId]="projId"
                    (scrollHiddenStatus)="addScollHiddenClass()">
                  </jni-invoice-preview-order-tracking>
                </p-panel>
              </div>
            </div>
            <div>
              <div class="cstm-collaspse">
                <p-panel
                  class="collapseable zeroHeight"
                  (onBeforeToggle)="onInvoiceEmailToggle()"
                  [collapsed]="collapseInvoiceEmailStatus"
                  [toggleable]="true"
                  [expandIcon]="'pi pi-angle-double-down'"
                  [collapseIcon]="'pi pi-angle-double-up'"
                  [ngClass]="{ active: collapseInvoiceEmailStatus }">
                  <ng-template #icons>
                    <ng-template #header>
                      <header
                        class="align-items-center d-flex has-border mt-3 ordersummary-header pb-2">
                        <a
                          class="btn-collapse"
                          (click)="onInvoiceEmailToggle()"
                          [ngClass]="{ active: collapseInvoiceEmailStatus }"
                          >{{ collapseInvoiceEmailHeading }}
                        </a>
                      </header>
                    </ng-template>
                  </ng-template>
                  <div class="row">
                    <div class="col-6 removepaddingtopinvoiceemail">
                      <jni-invoice-preview-invoice-emails
                        #invoiceEmail
                        [invoiceEmailListing]="invoiceEmailListing"
                        (invoiceEmailAddEvent)="invoiceEmailAdd()"
                        (invoiceEmailCopyBacEmailEvent)="
                          invoiceEmailCopyBacEmailEvent($event)
                        "
                        (invoiceEmailCopyBcEmailEvent)="
                          invoiceEmailCopyBcEmailEvent($event)
                        "
                        (invoiceEmailAddBcBacEmailEvent)="
                          invoiceEmailAddBcBacEmailEvent($event)
                        "
                        (invoiceEmailDeletedEvent)="invoiceEmailDelete($event)"
                        (invoiceEmailEditEvent)="invoiceEmailEdit($event)"
                        (invoiceEmailSaveEvent)="saveInvoiceEmailModel($event)"
                        [salesOrderId]="saleOrderId">
                      </jni-invoice-preview-invoice-emails>
                    </div>
                    <div class="col-6">
                      <div class="mt-1">
                        <div
                          class="d-flex mb-1 align-items-center justify-content-between">
                          <h2 class="mb-0">Quick Note</h2>
                          <p-button label="Send" (click)="onQuickQuote()" />
                        </div>
                        <textarea
                          pInputText
                          name=""
                          id=""
                          cols="30"
                          rows="10"
                          [(ngModel)]="quickQuote"></textarea>
                      </div>
                    </div>
                  </div>
                </p-panel>

                <div
                  class="row collapseable zeroHeight"
                  [ngClass]="{ active: collapseInvoiceEmailStatus }">
                  <div class="row"></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <ngx-extended-pdf-viewer
              [base64Src]="reportBase64String"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showPresentationModeButton]="true"
              [zoom]="pdfZoom"
              class="pdf-wdth"
              *ngIf="showPdfViewer"></ngx-extended-pdf-viewer>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-print-purchase-order
  [saleOrderId]="saleOrderId"
  [printPdfModal]="printPdfModal"
  [purchaseOrderLine]="purchaseOrderLine"
  (openPdfScreenModalEvent)="openPdfScreen($event)"
  (closePrintPdfModalEvent)="closePrinfPdfModal()">
</jni-print-purchase-order>

<jni-order-notes-sidebar
  #ordernotessidebar
  [isFromInvoiceSummary]="true"
  [(display)]="displaySidebar"
  [saleOrderId]="saleOrderId"
  [displaySideBeforeSubmittingStatus]="displaySideBeforeSubmittingStatus"
  (refreshOrderNotesGrid)="getSalesOrderNotes(saleOrderId)"
  (closeSidebar)="closeSideBarForOrderNotes()"
  (closeSidebarAndCallStatusApprovalCall)="
    closeSidebarAndCallStatusApprovalCall()
  "></jni-order-notes-sidebar>

<jni-modal-stacker
  *ngIf="orderTrackingModalStatus"
  [displayModal]="orderTrackingModalStatus"
  (closeEvent)="closeModalForOrderTracking()">
  <h1 class="panelHeading">Order Tracking Listing</h1>
  <div class="panelBody">
    <jni-invoice-preview-order-tracking
      [salesId]="salesId"
      [projId]="projId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeModalEvent)="closeModalForOrderTracking()"
      [forModalStacker]="true"></jni-invoice-preview-order-tracking>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="orderLinesDetailModalStatus"
  [displayModal]="orderLinesDetailModalStatus"
  (closeEvent)="closeModalForOrderLineDetails()">
  <h1 class="panelHeading">Order Lines Details Listing</h1>
  <div class="panelBody">
    <jni-invoice-preview-order-line-details
      [invoicePreviewNumber]="invoicePreviewNumber"
      (scrollHiddenStatus)="addScollHiddenClass()"
      [invoicePreviewLines]="invoicePreviewLines"
      [orderLineDetailsConsumesMessage]="
        orderLineDetailsConsumesMessage
      "></jni-invoice-preview-order-line-details>
  </div>
</jni-modal-stacker>
